import { Container, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import BaseTitle from "../../../common/base-title/base-title";

//import styles
import "./about-us-blog.scss";

function AboutUsBlog() {
    //general variables
    const { t } = useTranslation();

    return (
        <Container className="about-us-blog" maxWidth="xl">
            <Grid container item rowGap={{ xs: 1, md: 15 }} justifyContent="center" alignItems="center">
                <BaseTitle title={t("aboutUs")} dividerColor="1px solid var(--medium-gray-color)" />
                <Paper
                    elevation={3}
                    sx={{
                        maxWidth: {
                            xs: "100%",
                            sm: "80%",
                            md: "60%",
                        },
                        p: { xs: 2, sm: 3, md: 4 },
                    }}
                >
                    <Typography variant="body1" textAlign="justify" sx={{ fontSize: { xs: "0.875rem", md: "1rem" } }}>
                        {t("aboutUsDescription")}
                    </Typography>
                </Paper>
            </Grid>
        </Container>
    );
}

export default AboutUsBlog;
